import request from '@/utils/request'
export const getVersionInfo = (data) => {
    return request({
        url: 'VersionControl/byData',
        method: 'post',
        data
    })
}

export const saveVersionInfo = (data) => {
    return request({
        url: 'VersionControl/save',
        method: 'post',
        data
    })
}